import ImageGallery, { ReactImageGalleryProps } from 'react-image-gallery';
import { Close as CloseIcon } from '@mui/icons-material';
import { Dialog, DialogContent, IconButton } from '@mui/material';

type ImageType = {
	original: string;
	thumbnail: string;
	description: string;
};

export const ImagesGalleryModal = ({
	startIndex,
	items,
	isOpen,
	onClose = () => null,
	...restProps
}: ReactImageGalleryProps & {
	startIndex: number;
	items: ImageType[];
	isOpen: boolean;
	onClose: () => void;
}) => {
	console.log(items, 'itemsitemsitems');
	return (
		<Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="md">
			<DialogContent sx={{ position: 'relative', p: 0 }}>
				<ImageGallery startIndex={startIndex} items={items} {...restProps} />
				<IconButton
					onClick={onClose}
					sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}
				>
					<CloseIcon />
				</IconButton>
			</DialogContent>
		</Dialog>
	);
};
